import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import InstallPrompt from "./InstallPrompt";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
    <InstallPrompt />
  </React.StrictMode>
);

// Register PWA service worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* ignore registration errors */
    });
  });
}
